/**
 * 对账(S8)的文案。命名空间 `visualGameAdmin.llm.recon.*`。
 *
 * **页面上不讲规则,每一行自己说自己**:`kind.*` 是归类徽标(label 显示、hint 挂在 title 上),
 * `unpriceable.*` 是「成本事实未记录」的条数标签。原来那两大段口径说明是写给改代码的人的,已经删了 ——
 * 它们在 `plan/llm-admin/` 和 `assembly/llm-admin/recon.js` 里。
 *
 * `en` 与 `zh` 的 key 集必须逐字相同 —— `test/i18n.test.js` 拍平后逐项比对六个语种。
 */

export const en = {
  title: 'Reconciliation',
  window: {
    rangeLabel: 'Window',
    since: 'From',
    until: 'To',
    limit: 'Rows',
    apply: 'Search',
    range: { '24h': 'Last 24h', '7d': 'Last 7 days', '30d': 'Last 30 days' },
  },
  table: {
    title: 'Billing anomalies',
    createdAt: 'Time',
    requestId: 'Request',
    user: 'User',
    model: 'Provider / model',
    kind: 'Kind',
    tokens: 'Tokens',
    tokensHint: 'prompt / completion / cached',
    expectedAmount: 'Supplier cost',
    expectedPoints: 'Expected points',
    view: 'Open',
  },
  kind: {
    ok: { label: 'Succeeded, unbilled', hint: 'Call went through, nobody was charged' },
    error: { label: 'Failed with usage', hint: 'Upstream answered, settlement failed' },
    aborted: { label: 'Failed with usage', hint: 'Upstream answered, settlement failed' },
  },
  unpriceable: {
    supplier_cost_not_recorded: { label: 'Supplier cost missing', hint: 'Supplier cost was not recorded' },
  },
  pagination: {
    prev: 'Previous',
    next: 'Next',
  },
  empty: {
    title: 'No billing anomalies',
    description: 'Every call here has a billing row.',
  },
}

export const zh = {
  title: '对账',
  window: {
    rangeLabel: '时间窗',
    since: '开始',
    until: '结束',
    limit: '每页',
    apply: '查询',
    range: { '24h': '24 小时', '7d': '7 天', '30d': '30 天' },
  },
  table: {
    title: '账目异常',
    createdAt: '时间',
    requestId: '调用',
    user: '用户',
    model: '厂商 / 模型',
    kind: '归类',
    tokens: 'Token',
    tokensHint: '输入 / 输出 / 缓存命中',
    expectedAmount: '供应商成本',
    expectedPoints: '应扣积分',
    view: '查看',
  },
  kind: {
    ok: { label: '成功未扣款', hint: '调用成功，未生成积分流水' },
    error: { label: '失败但有用量', hint: '供应商已返回用量，未完成结算' },
    aborted: { label: '失败但有用量', hint: '供应商已返回用量，未完成结算' },
  },
  unpriceable: {
    supplier_cost_not_recorded: { label: '供应商成本缺失', hint: '这次调用没有记录供应商成本' },
  },
  pagination: {
    prev: '上一页',
    next: '下一页',
  },
  empty: {
    title: '这段时间没有账目异常',
    description: '所有有用量的调用均已完成账目记录。',
  },
}
